import { render, staticRenderFns } from "./BoIncScheme.vue?vue&type=template&id=18c3d3be&"
import script from "./BoIncScheme.vue?vue&type=script&lang=js&"
export * from "./BoIncScheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports